// import uploader component
import {UploaderComponent} from "@syncfusion/ej2-react-inputs";
import React from "react";

export default function FileUpload({myRef}) {
  return <UploaderComponent id='uploader' ref={myRef}/>;
}
